module.exports = function (obj, his_self) {
  //    let obj = {
  //      spacekey : spacekey ,
  //      moved_units : moved_units ,
  //      unmoved_units : unmoved_units ,
  //    };
  //    {
  //	faction : ,
  //	idx : available_units[idx] ,
  //    }

  var html = "\n\t  <div class=\"fortification-overlay\">\n            <div class=\"help\">\n\t      <div class=\"fortification-from\">".concat(his_self.returnSpaceName(obj.spacekey), "</div> into <div class=\"fortification-to\">Fortification</div>\n\t    </div>\n\t    <div class=\"fortification-table\">\n\t      <div class=\"fortification-source\">");
  for (var i = 0; i < obj.unmoved_units.length; i++) {
    var ucss = '';
    var uclass = '';
    var utype = obj.unmoved_units[i].type;
    if (utype != 'regular' && utype != 'mercenary' && utype != 'cavalry' && obj.unmoved_units[i].reformer != true) {
      uclass = 'army-unit';
      ucss = "background-image:url('/his/img/tiles/army/".concat(his_self.army[utype].img, "');background-size:cover;");
    }
    html += "\n\t     <div class=\"fortification-unit option ".concat(uclass, " ").concat(obj.unmoved_units[i].type, "\" id=\"").concat(obj.unmoved_units[i].faction, "-").concat(obj.unmoved_units[i].idx, "\">\n\t       <div class=\"fortification-unit-img\" style=\"").concat(ucss, "\"></div>\n\t       <div class=\"fortification-unit-type\">").concat(obj.unmoved_units[i].type, "</div>\n\t       <div class=\"fortification-type-faction\">").concat(obj.unmoved_units[i].faction, "</div>\n             </div>\n\t");
  }
  html += "</div>";
  html += "<div class=\"fortification-destination\">";
  for (var _i = 0; _i < obj.moved_units.length; _i++) {
    var _ucss = '';
    var _uclass = '';
    var _utype = obj.moved_units[_i].type;
    if (_utype != 'regular' && _utype != 'mercenary' && _utype != 'cavalry') {
      _uclass = 'army-unit';
      _ucss = "background-image:url('/his/img/tiles/army/".concat(his_self.army[_utype].img, "');background-size:cover;");
    }
    html += "<div class=\"fortification-unit option ".concat(_uclass, " ").concat(obj.moved_units[_i].type, "\" id=\"").concat(obj.moved_units[_i].faction, "-").concat(obj.moved_units[_i].idx, "\">\n\t       <div class=\"fortification-unit-img\" style=\"").concat(_ucss, "\"></div>\n\t       <div class=\"fortification-unit-type\">").concat(obj.moved_units[_i].type, "</div>\n\t       <div class=\"fortification-type-faction\">").concat(obj.moved_units[_i].faction, "</div>\n\t    </div>");
  }
  html += "</div></div><div class=\"fortification-submit-button option\" id=\"end\">confirm and fortify</div></div>";
  return html;
};